/**
 * /dashboard/performance/reviews — Review cycles list.
 *
 * Migration note: port of
 * frontend/src/app/(dashboard)/dashboard/performance/reviews/page.tsx.
 */

import { createFileRoute } from "@tanstack/react-router";
import { PerformanceModuleShell } from "@/components/shared/performance-module-shell";
import { PerformanceFeatureGate } from "@/components/performance/performance-feature-gate";
import { ReviewsTab } from "@/components/performance/reviews-tab";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/performance/reviews/")({
  component: PerformanceReviewsRoute,
});

function PerformanceReviewsRoute() {
  return (
    <PerformanceModuleShell
      title="Review cycles"
      description="Find the cycle your reviews live in. HR runs the cycle from there."
    >
      <PerformanceFeatureGate>
        <ReviewsTab />
      </PerformanceFeatureGate>
    </PerformanceModuleShell>
  );
}
